import React, {useEffect, useState} from 'react'
import {Iproject, projectInitValues as initialValues} from '../../models/ProjectModel'
import * as Yup from 'yup'
import {useFormik} from 'formik'
import axios from 'axios'
import {useLocation} from 'react-router-dom'
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import {useNavigate} from 'react-router-dom'
import {useIntl} from 'react-intl'

import {Input3} from '../../../../../../components/Forms/Input'
import {updateProject, deleteProject} from '../../components/projects-list/core/_requests'
import {Toolbar2} from '../../../../../../_metronic/layout/components/toolbar/Toolbar2'
import {PageTitle} from '../../../../../../_metronic/layout/core'
import {Dropdown} from 'primereact/dropdown'
import {MultiSelect} from 'primereact/multiselect'

const API_URL = process.env.REACT_APP_API_URL || 'api'

export interface UseOption {
  value: string
  label: string
  color?: string
  isFixed?: boolean
  isDisabled?: boolean
}

const FormProjectEdit: React.FC = () => {
  const intl = useIntl()
  const location = useLocation()
  const MySwal = withReactContent(Swal)
  const navigate = useNavigate()
  const [loading, setLoading] = useState(false)

  //USUARIOS
  const [selectedCoordinator, setSelectedCoordinator] = useState(null);
  const [coordinator, setCoordinator] = useState([])

  //USUARIOS SGA
  const [selectAddResponsibleSGA, setSelectedAddResponsibleSGA] = useState([])

  //USUARIOS SGT
  const [selectAddResponsibleSGT, setSelectedAddResponsibleSGT] = useState([])

  const {uuid, coordinator_id, sga_responsibles, sgt_responsibles} = location.state as Iproject

  useEffect(() => {
    loadOptionUsers()
    let project = location.state as Iproject
    if (location.state) {
      if (project.code) {
        formik.setFieldValue('code', project.code)
      }
      if (project.description) {
        formik.setFieldValue('description', project.description)
      }
      if (project.uuid) {
        formik.setFieldValue('uuid', project.uuid)
      }

      if (project.coordinator_id) {
        formik.setFieldValue('coordinator_id', project.coordinator_id)
      }
    }
  }, [])

  // VALIDAÇÃO DOS DADOS
  const projectSchema = Yup.object().shape({
    code: Yup.string()
      .required(intl.formatMessage({id: 'AUTH.VALIDATION.REQUIRED_FIELD'}))
      .min(3, intl.formatMessage({id: 'COMMON.MIN_CHARACTER_3'}))
      .max(255, intl.formatMessage({id: 'COMMON.MAX_CHARACTER_255'})),

    description: Yup.string()
      .required(intl.formatMessage({id: 'AUTH.VALIDATION.REQUIRED_FIELD'}))
      .min(3, intl.formatMessage({id: 'COMMON.MIN_CHARACTER_3'}))
      .max(9999, intl.formatMessage({id: 'COMMON.MAX_CHARACTER_9999'})),
  })


  // ENVIO DOS DADOS
  const formik = useFormik<Iproject>({
    initialValues,
    validationSchema: projectSchema,
    onSubmit: async (values) => {
      setLoading(true)
      console.log(values)
      try {
        await updateProject(values)
        setLoading(false)
        Swal.fire({
          icon: 'success',
          title: intl.formatMessage({id: 'PROJECT.SWAL_EDIT'}),
          showConfirmButton: false,
          timer: 2000,
        })
        navigate('/projects', {replace: true})
      } catch (error) {
        Swal.fire({
          icon: 'error',
          title: intl.formatMessage({id: 'PROJECT.SWAL_EDIT_ERROR'}),
          showConfirmButton: false,
          timer: 2000,
        })

        setLoading(false)
      }
    },
  })

  // LIMPAR OS DADOS DO FORMULÁRIO
  function resetInputs() {
    formik.resetForm()
    setSelectedAddResponsibleSGA([])
    setSelectedAddResponsibleSGT([])
    setSelectedCoordinator(null)
  }

  async function deleteProjectF(uuid: string) {
    deleteProject(uuid)
      .then(() => {
        Swal.fire({
          icon: 'success',
          title: intl.formatMessage({id: 'PROJECT.SWAL_DELETE'}),
          showConfirmButton: false,
          timer: 2000,
        })
        navigate('/projects', {replace: true})
      })
      .catch(() => {
        Swal.fire({
          icon: 'error',
          title: intl.formatMessage({id: 'PROJECT.SWAL_DELETE_ERROR'}),
          showConfirmButton: false,
          timer: 2000,
        })
      })
  }

  function deleteMsgProject() {
    MySwal.fire({
      title: intl.formatMessage({id: 'PROJECT.SWAL_DELETE_QUESTION'}),
      text: intl.formatMessage({id: 'COMMON.SWAL_DELETE_TEXT'}),
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: intl.formatMessage({id: 'COMMON.SWAL_DELETE_MSG'}),
      cancelButtonText: intl.formatMessage({id: 'COMMON.CANCEL_BUTTON'}),
    }).then((result) => {
      if (result.value) {
        if (uuid !== undefined) deleteProjectF(uuid)
      }
    })
  }

  {/*---------------------- INICIO USUARIOS OPTIONS ----------------------*/
  }
  const loadOptionUsers = () => {
    setTimeout(() => {
      getUsers()
      let users: any = []
      let option_coodinator: any = []
      let option_sga_user_id: any = []
      let option_sgt_user_id: any = []

      let initial_sga_user_id: any = []
      let initial_sgt_user_id: any = []

      sga_responsibles?.map((sga: any) => {
        return initial_sga_user_id.push(sga.id)
      })
      sgt_responsibles?.map((sgt: any) => {
        return initial_sgt_user_id.push(sgt.id)
      })

      async function getUsers() {
        const {data} = await axios.get(API_URL + '/v1/users/select2')
        let Response = data.results

        if (Response) {
          for (const element of Response) {
            const user: any = {
              code: element.id,
              name: element.username,
            }

            users.push(user)

            //DEFINE USUARIO COORDENADOR
            if (coordinator_id === element.id) {
              option_coodinator.push(user)
            }

            //DEFINE USUARIOS RESPONSAVEIS SGA
            if (sga_responsibles) {
              for (let j = 0; j < sga_responsibles?.length; j++) {
                if (sga_responsibles[j].id === element.id) {
                  option_sga_user_id.push(user)
                }
                setSelectedAddResponsibleSGA(option_sga_user_id)
              }
            }

            //DEFINE USUARIOS RESPONSAVEIS SGT
            if (sgt_responsibles) {
              for (let j = 0; j < sgt_responsibles?.length; j++) {
                if (sgt_responsibles[j].id === element.id) {
                  option_sgt_user_id.push(user)
                }
                setSelectedAddResponsibleSGT(option_sgt_user_id)
              }
            }
          }
        }
        setSelectedCoordinator(option_coodinator[0])
      }

      setCoordinator(users)
      formik.setFieldValue('sga_user_id', initial_sga_user_id)
      formik.setFieldValue('sgt_user_id', initial_sgt_user_id)

      return users
    }, 2000)
  }
  {/*---------------------- FIM USUARIOS OPTIONS ----------------------*/
  }

  return (
    <div className='card card-custom mt-n8'>
      {/* Component Header de Cadastros. */}

      <Toolbar2 icon={false} subtitle={intl.formatMessage({id: 'COMMON.BACK_BUTTON'})} />
      <PageTitle breadcrumbs={[]}>{intl.formatMessage({id: 'PROJECT.TITLE_EDIT'})}</PageTitle>

      <div id='kt_account_profile_details' className='collapse show'>
        <form onSubmit={formik.handleSubmit} noValidate className='form'>
          <div className='card-body border-top p-9'>

            {/*---------------------- INICIO CODE ----------------------*/
            }
            <Input3
              title={intl.formatMessage({id: 'PROJECT.INPUT_CODE'})}
              placeholder={intl.formatMessage({id: 'PROJECT.INPUT_CODE_PLACEHOLDER'})}
              {...formik.getFieldProps('code')}
              required
            />
            {formik.touched.code && formik.errors.code && (
              <div className='fv-plugins-message-container text-danger'>
                <div className='fv-help-block'>{formik.errors.code}</div>
              </div>
            )}
            {/*---------------------- FIM CODE ----------------------*/}


            {/*---------------------- INICIO DESCRIÇÃO ----------------------*/
            }
            <Input3
                title={intl.formatMessage({id: 'COMMON.DESCRIPTION'})}
                placeholder={intl.formatMessage({id: 'COMMON.INPUT_DESCRIPTION_PLACEHOLDER'})}
                {...formik.getFieldProps('description')}
                required
            />
            {formik.touched.description && formik.errors.description && (
                <div className='fv-plugins-message-container text-danger'>
                  <div className='fv-help-block'>{formik.errors.description}</div>
                </div>
            )}
            {/*---------------------- INICIO DESCRIÇÃO ----------------------*/
            }


            {/*---------------------- INICIO COORDENADOR ----------------------*/}
            <div className='row mb-3'>
              <label className='col-lg-2 col-form-label fw-bold '>
                {intl.formatMessage({id: 'COMMON.INPUT_COORDINADOR_ID'})}
              </label>

              <div className='col-lg-12'>
                <Dropdown
                  className='form-control form-control-sm form-control-solid p-0 ps-3 border border-white'
                  value={selectedCoordinator}
                  options={coordinator}
                  onChange={(e: any) => {
                    e.target.value !== undefined
                      ? formik.setFieldValue('coordinator_id', e.target.value.code)
                      : formik.setFieldValue('coordinator_id', undefined)

                    setSelectedCoordinator(e.value)
                  }}
                  optionLabel='name'
                  showClear
                  filter
                  placeholder={intl.formatMessage({id: 'SELECT.INPUT_COORDINATOR'})}
                />
              </div>
            </div>
            {/*---------------------- FIM COORDENADOR ----------------------*/}


            {/*---------------------- INÍCIO SGA USER ----------------------*/}
            <div className='row mb-3'>
              <label className='col-lg-2 col-form-label fw-bold '>
                <span className='required'>
                  {intl.formatMessage({id: 'COMMON.INPUT_SGA_USER_ID'})}
                </span>
              </label>

              <div className='col-lg-12'>
                <MultiSelect
                  className='form-control form-control-sm form-control-solid p-0 ps-3 border border-white'
                  value={selectAddResponsibleSGA}
                  options={coordinator}
                  showClear
                  onChange={(e: any) => {
                    e.value !== null
                      ? formik.setFieldValue(
                          'sga_user_id',
                          e.value.map((v: any) => {
                            return v.code
                          })
                        )
                      : formik.setFieldValue('sga_user_id', undefined)
                    setSelectedAddResponsibleSGA(e.value)
                  }}
                  placeholder={intl.formatMessage({id: 'SELECT.INPUT_SGA_USER'})}
                  optionLabel='name'
                  filter
                  display='chip'
                />
              </div>
            </div>
            {/*---------------------- FIM SGA USER ----------------------*/}


            {/*---------------------- INICIO SGT USER ----------------------*/}
            <div className='row mb-3'>
              <label className='col-lg-2 col-form-label fw-bold '>
                <span className='required'>
                  {intl.formatMessage({id: 'COMMON.INPUT_SGT_USER_ID'})}
                </span>
              </label>

              <div className='col-lg-12'>
                <MultiSelect
                  className='form-control form-control-sm form-control-solid p-0 ps-3 border border-white'
                  value={selectAddResponsibleSGT}
                  options={coordinator}
                  showClear
                  style={{
                    fontFamily: 'Poppins',
                    fontSize: '1.15rem',
                    fontWeight: 'medium',
                  }}
                  onChange={(e: any) => {
                    e.value !== null
                      ? formik.setFieldValue(
                          'sgt_user_id',
                          e.value.map((v: any) => {
                            return v.code
                          })
                        )
                      : formik.setFieldValue('sgt_user_id', undefined)
                    setSelectedAddResponsibleSGT(e.value)
                  }}
                  placeholder={intl.formatMessage({id: 'SELECT.INPUT_SGT_USER'})}
                  optionLabel='name'
                  filter
                  display='chip'
                />
                {formik.touched.sgt_user_id && formik.errors.sgt_user_id && (
                  <div className='fv-plugins-message-container text-danger'>
                    <div className='fv-help-block'>{formik.errors.sgt_user_id}</div>
                  </div>
                )}
              </div>
            </div>
            {/*---------------------- FIM SGT USER ----------------------*/}


            {/*---------------------- INICIO SUBMIT ----------------------*/}
            <div className='d-flex justify-content-end py-6'>
              <button type='submit' className='btn btn-sm btn-primary' disabled={loading}>
                {!loading && intl.formatMessage({id: 'COMMON.SAVE_BUTTON'})}
                {loading && (
                  <span className='indicator-progress' style={{display: 'block'}}>
                    {intl.formatMessage({id: 'COMMON.SAVING_BUTTON'})}{' '}
                    <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                  </span>
                )}
              </button>
              <button type='reset' onClick={resetInputs} className='btn btn-sm btn-secondary mx-2'>
                {intl.formatMessage({id: 'COMMON.CLEAR_BUTTON'})}
              </button>

              <button
                type='button'
                onClick={deleteMsgProject}
                className='btn btn-sm btn-danger ml-1'
              >
                {intl.formatMessage({id: 'COMMON.DELETE_BUTTON'})}
              </button>
            </div>
            {/*---------------------- FIM SUBMIT ----------------------*/}
          </div>
        </form>
      </div>
    </div>
  )
}
export {FormProjectEdit}
